// extracted by mini-css-extract-plugin
export default {"prevArrow":"page2_prevArrow__b9JSy","nextArrow":"page2_nextArrow__qaqwh"};